export const MIN_TIMESTAMP_SEC = 946684800; // Jan 1, 2000 in seconds since Unix epoch
export const MAX_TIMESTAMP_SEC = 4102444800; // Jan 1, 2100 in seconds since Unix epoch

export function isTimestampSecWithinSupportedRange(timestampSec: number): boolean {
  return (
    Number.isFinite(timestampSec) &&
    timestampSec >= MIN_TIMESTAMP_SEC &&
    timestampSec <= MAX_TIMESTAMP_SEC
  );
}

export function getIsoDateTimestampSec(dateString: string): number | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateString);
  if (match == null) {
    return null;
  }

  const [, yearString, monthString, dayString] = match;
  const year = Number(yearString);
  const month = Number(monthString);
  const day = Number(dayString);
  const timestampMs = Date.UTC(year, month - 1, day);
  const date = new Date(timestampMs);

  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return null;
  }

  return timestampMs / 1000;
}

const TIMEZONE_AWARE_ISO_TIMESTAMP_REGEX =
  /^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,6}))?)?(Z|[+-]\d{2}:\d{2})$/;

export function getIsoDateOrTimestampSec(value: string): number | null {
  const dateTimestampSec = getIsoDateTimestampSec(value);
  if (dateTimestampSec != null) {
    return dateTimestampSec;
  }

  const match = TIMEZONE_AWARE_ISO_TIMESTAMP_REGEX.exec(value);
  if (match == null) {
    return null;
  }

  const [, datePart, hourString, minuteString, secondString = "0", , timezone] = match;
  if (getIsoDateTimestampSec(datePart) == null) {
    return null;
  }

  const hour = Number(hourString);
  const minute = Number(minuteString);
  const second = Number(secondString);
  if (hour > 23 || minute > 59 || second > 59) {
    return null;
  }

  if (timezone !== "Z") {
    const timezoneHour = Number(timezone.slice(1, 3));
    const timezoneMinute = Number(timezone.slice(4, 6));
    if (timezoneHour > 23 || timezoneMinute > 59) {
      return null;
    }
  }

  const timestampMs = Date.parse(value);
  return Number.isFinite(timestampMs) ? timestampMs / 1000 : null;
}
